import { Scope } from '@unform/core'

import { FormGroup } from '~/components/unform'

import FormatQuantityAds from '../FormQuantity'

const FormatSponsoredBrands: React.FC<{ type: AdSizeType }> = ({ type }) => (
  <FormGroup className="span-full">
    <Scope
      path={type === 'video' ? 'sponsored_brand_video' : 'sponsored_brand'}
    >
      <FormatQuantityAds />
    </Scope>
  </FormGroup>
)

export default FormatSponsoredBrands
